<form [formGroup]="projectForm">
  <div class="space-y-12">
    <div class="border-b border-gray-900/10 pb-6">
      <p class="mt-1 text-sm/6 text-gray-600">You can edit the Project here.</p>

      <div class="grid gap-6 mt-6">
        <div class="col-span-full border-t border-gray-900/10 pt-4">
          <app-text-area
            [fieldConfigurationAddress]="'project.productLine'"
            [label]="'Product Line'"
            [maxRows]="1"
            [formControl]="productLine"
            [fieldIsRequired]="false"
            [displayChangeIndicator]="false"
          ></app-text-area>
        </div>
        <div class="col-span-full pt-4">
          <app-text-area
            [fieldConfigurationAddress]="'project.shortDescription'"
            [label]="'Short Description'"
            [maxRows]="1"
            [formControl]="shortDescription"
            [fieldIsRequired]="false"
            [displayChangeIndicator]="false"
          ></app-text-area>
        </div>
        <div class="col-span-full pt-4">
          <app-text-area
            [fieldConfigurationAddress]="'project.internalNotes'"
            [label]="'Internal notes'"
            [formControl]="internalNotes"
            [fieldIsRequired]="false"
            [displayChangeIndicator]="false"
          ></app-text-area>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-6 flex items-center justify-end gap-x-6">
    <button
      type="button"
      [disabled]="projectForm.invalid"
      (click)="update()"
      class="crud-btn-sidebar"
      appAgentAction
      agent="edit-project-save"
      businessObject="project"
      [businessId]="$safeNavigationMigration(project?.id)"
      action="save"
    >
      <app-floppy-icon></app-floppy-icon>
    </button>
  </div>
</form>
